import ReactIcon from "../assets/Icons/react-icon.png";
import NodeIcon from "../assets/Icons/node-js-icon.png";
import JsIcon from "../assets/Icons/js-logo.png";
import TsIcon from "../assets/Icons/Typescript-logo.png";
import HtmlIcon from "../assets/Icons/html-logo.png";
import CssIcon from "../assets/Icons/css-logo.png";
import ScssIcon from "../assets/Icons/cssc-icon.png";
import GitIcon from "../assets/Icons/git-logo.png";
import GitHubIcon from "../assets/Icons/gitHub-logo.png";

const technologies = [
  {
    value: "React.Js",
    icon: ReactIcon,
  },
  {
    value: "Node.js",
    icon: NodeIcon,
  },
  {
    value: "JavaScript",
    icon: JsIcon,
  },
  {
    value: "TypeScript",
    icon: TsIcon,
  },
  {
    value: "HTML",
    icon: HtmlIcon,
  },
  {
    value: "CSS",
    icon: CssIcon,
  },
  {
    value: null,
    icon: ScssIcon,
  },
  {
    value: "Git",
    icon: GitIcon,
  },
  {
    value: "GitHub",
    icon: GitHubIcon,
  },
];

export default technologies;
